export const items = [
  {
    label: "Home",
    key: "/",
  },
  {
    label: "Menu",
    key: "/menu",
  },
  // {
  //   label: "Order Online",
  //   key: "/order",
  // },
  {
    label: "About",
    key: "/about",
  },
  {
    label: "Contact us",
    key: "/contact",
  },
  // {
  //   label: "Order Tracking",
  //   key: "/orderTracking",
  // },
];
